import { useEffect } from 'react';
import { pageNavigating, pageNavigationCanceled } from 'events/app';
import { useDispatch } from 'react-redux';

export default function useNavigationMonitor(timeoutRef) {
  const dispatch = useDispatch();
  const handleBeforeunload = () => {
    dispatch(pageNavigating());
    timeoutRef.current = setTimeout(() => dispatch(pageNavigationCanceled()), 30000);
  };
  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeunload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeunload);
      clearTimeout(timeoutRef.current);
    };
  }, []);
}
